import {useEffect, useState} from 'react';
import {useWebsocket} from '../components/socketContext/socketContext';
import {subscribeApiSocket} from '../api/socket';
import {fetchGames} from '../api/api';
import {useQueryClient, useQuery} from 'react-query'
import RouteUtils from '../utils/routeUtils'
import _ from 'lodash';

export const useGamesListQuery = (league, season, gameTime) => {
    const socket = useWebsocket();
    const queryClient = useQueryClient();
    const [enabled, setEnabled] = useState(true);

    const leagueFilter = RouteUtils.getLeague(league);

    const {isLoading, error, data} = useQuery([league, {gameTime, season}],
        () => fetchGames(leagueFilter, season, gameTime), {enabled});

    const [games, setGames] = useState(data || []);
    const [gameUpdated, setGameUpdated] = useState(false);

    let timer;
    const onSocketMessage = (m) => {
        let data = JSON.parse(m.data);

        if (!data || !data.matchupId) {
            console.warn(`Socket ignoring unexpected message: ${JSON.stringify(data)}`);
            return;
        }

        setGames((games) => {
            const newGames = [...games];
            newGames.forEach(game => {
                if (game.id === data.matchupId) {
                    if (data.eventName === 'status_updated') {
                        game = {...game, ...data.data};
                        setGameUpdated(true);
                    } else if (data.eventName === 'line_updated') {
                        data.data.newValue.forEach(value => {
                            value['updated'] = true;
                        });
                        game.markets[data.data.marketName][data.data.bookName] = data.data.newValue;
                        setGameUpdated(true);
                        console.log({data});
                    }
                }
            });
            return newGames;
        });

        if (data.eventName === 'line_updated' && !timer) {
            timer = setTimeout(() => {
                setGames((games) => {
                    const newGames = [...games];
                    newGames.forEach(game => {
                        for (let market in game.markets) {
                            for (let book in game.markets[market]) {
                                game.markets[market][book].forEach(value => {
                                    value['updated'] = false;
                                });
                            }
                        }
                    });
                    setGameUpdated(true);
                    return newGames;
                });
                clearTimeout(timer);
                timer = null;
            }, 60000);
        }
    }

    const onSocketOpen = () => {
        if (games && games.length > 0) {
            subscribeApiSocket(socket, games.map(g => g.id));
        }
    }

    useEffect(() => {
        socket.addEventListener('message', onSocketMessage);
        socket.addEventListener('open', onSocketOpen);

        return () => {
            socket.removeEventListener('message', onSocketMessage);
            socket.removeEventListener('open', onSocketOpen);
        }
    }, []);

    useEffect(() => {
        const games = data || [];

        const sortedGamesByDate = _.orderBy(games, g => {
            return new Date(g.scheduled_datetime);
        });
        const sortedGamesByComplete = _.orderBy(sortedGamesByDate, g => {
            return g.status === 'complete'
        }, ["asc"]);
        const sortedGamesByClosed = _.orderBy(sortedGamesByComplete, g => {
            return g.status === 'closed'
        }, ["asc"]);
        const sortedGamesByPostponed = _.orderBy(sortedGamesByClosed, g => {
            return g.status === 'postponed'
        }, ["asc"]);
        const sortedGamesBySchedule = _.orderBy(sortedGamesByPostponed, g => {
            return g.status === 'cancelled'
        }, ["asc"]);

        setGames(sortedGamesBySchedule);
        setGameUpdated(false);

        if (!data)
            return;

        setEnabled(false);

        sortedGamesBySchedule.forEach(g => queryClient.setQueryData(['game', makeCacheId(league, g)], g));
        subscribeApiSocket(socket, sortedGamesBySchedule.map(g => g.id));
    }, [data, isLoading, gameUpdated]);

    return {isLoading, games};

}

const makeCacheId = (league, game) => {
    const {slugs} = game;
    const {away_slug, home_slug, scheduled_slug} = slugs;
    return {league, homeTeam: home_slug, awayTeam: away_slug, date: scheduled_slug};
}